import { useQuery } from '@tanstack/react-query';
import type {
  CustomerResponseDto,
  CustomerSortBy,
  ListParams,
} from '@relay-towing/api';
import { useHybridAuth } from '../../hooks/useHybridAuth';
import { useDriverStateV2 } from '../../hooks/useDriverStateV2';
import { getStoredSelectedCompanyId } from '../../hooks/userCompanies.shared';
import { getList } from '../list';

export const useGetCustomers = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { driver } = useDriverStateV2();
  // An office member with no Driver row has no driver company; the stored
  // selection stands in, as it does for creating a call.
  const companyId = driver?.companyId || getStoredSelectedCompanyId();

  return useQuery({
    queryKey: ['customers', companyId],
    queryFn: async () => {
      if (!companyId) {
        throw new Error('Company ID not available');
      }

      const token = await getAccessTokenSilently();
      // Every account on one page: the call forms offer them all in a single
      // picker, so there is nothing to page through.
      const params = {
        pageNo: 1,
        pageSize: 1000,
      } satisfies ListParams<CustomerSortBy>;

      return getList<CustomerResponseDto>('/customers', params, {
        token,
        companyId,
      });
    },
    enabled: !!companyId,
  });
};
